import * as Icons from "heroicons-react";
import Swal from "sweetalert2";
import { useEffect, useState } from "react";
import { Toaster } from "react-hot-toast";
import "react-loading-skeleton/dist/skeleton.css";
import ReactPaginate from "react-paginate";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import {
  useCategoryCountQuery,
  useAllSubCategoryQuery,
  useDeleteCategoryMutation,
} from "../../services/categoryApi";
import Header from "../Common/Header/Header";
import LoadingModal from "../Common/Modal/LoadingModal";
import SideBar from "../Common/SideBar/SideBar";
import { signInUser } from "../Utility/Auth";
import "./Category.css";

const SubCategories = () => {
  const auth = signInUser();
  const lang = useSelector((state) => state.languageReducer);

  const { aamarId } = auth;
  let i = 1;
  const [q, setQ] = useState("");

  const [loader, setLoader] = useState(false);
  const handleLoaderClose = () => setLoader(false);

  const [deleteCategory] = useDeleteCategoryMutation();

  const { data, error, isLoading, isFetching, isSuccess, refetch } =
    useAllSubCategoryQuery({
      aamarId,
      q,
    });

  // console.log("SubCategory", data);

  useEffect(() => {
    data ? setLoader(false) : setLoader(true);
  }, [data]);
  // console.log(data);
  useEffect(() => {
    isFetching ? setLoader(true) : setLoader(false);
  }, [data, isLoading, isFetching]);

  const handleSearch = (e) => {
    setQ(e.target.value);
    refetch();
  };

  const deleteHandler = async (id) => {
    const result = await Swal.fire({
      title: "Are you Sure?",
      text: "Delete this Category?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    });

    if (result.isConfirmed) {
      setLoader(true);
      try {
        const res = await deleteCategory(id);
        if (res) {
          // TODO::
          // add error hendaler for delete error
          console.log(res);
          Swal.fire("Deleted!", "Category has been deleted.", "success");
        } else {
          console.log("Delete Operation Canceled by Category!");
          return;
        }
      } catch (err) {
        console.log(err);
      } finally {
        setLoader(false);
      }
    }
  };

  return (
    <div>
      <div className="container-fluid">
        <LoadingModal
          title={"Please Wait"}
          onShow={loader}
          handleClose={handleLoaderClose}
        ></LoadingModal>
        <div className="row">
          <div className="col-md-2">
            <SideBar></SideBar>
          </div>
          <div className="col-md-10">
            <div className="row">
              <div className="col-md-12">
                <Header title={lang?.allSubCategories}></Header>
              </div>

              <div className="col-md-3 mt-2 mb-2">
                <form>
                  <div className="input-group mb-3">
                    <input
                      className="form-control ms-2 rounded"
                      type="text"
                      placeholder="Search Sub Category . . . ."
                      onKeyUp={(e) => handleSearch(e)}
                    />
                  </div>
                </form>
              </div>

              {/* <div className="col-md-9  mt-2 mb-2">Filters</div> */}
              <div className="col-md-9   mt-md-2 mb-2">
                <div className="float-end">
                  <Link to="./addSubCategory" className="btn btn-dark float-end ">
                    <Icons.Plus className="icon-edit" size={20}></Icons.Plus>
                    {lang?.addSubCategory || "Add Sub Category"}
                  </Link>
                  <Link
                    className="btn btn-dark mb-2 float-end me-2 "
                    to="/subcategory/importSubCategory"
                  >
                    <Icons.PlusOutline size={22}></Icons.PlusOutline>{" "}
                    {lang?.importSubCategories || "Import Sub Categories"}
                  </Link>
                </div>
              </div>
            </div>

            <div
              className="table-responsive"
              // style={{ maxHeight: "400px", overflowY: "auto" }}
            >
              <table className="table table-striped ">
                <thead>
                  <tr>
                    <th scope="col">#</th>
                    <th scope="col">Sub Category</th>
                    <th scope="col">Code</th>
                    <th scope="col">Group</th>
                    <th scope="col">Category</th>
                    {/* <th scope="col">MC ID</th> */}
                    <th scope="col">Actions </th>
                  </tr>
                </thead>
                <tbody>
                  {/* {isLoading && <h2>...Loading</h2>}
                {isFetching && <h2>...isFetching</h2>}
                {error && <h2>Something went wrong</h2>} */}
                  {data?.length > 0 ? (
                    data?.map((category) => (
                      <tr key={category?._id}>
                        <th scope="row">{i++}</th>
                        <td>{category?.name}</td>
                        <td>{category?.code}</td>
                        <td>{category?.group?.name || "-"}</td>
                        <td>
                          {category?.mc?.name}
                        </td>
                        {/* <td>{category?.mcId}</td> */}
                        <td>
                          {/* <Link to={`/category/${category._id}`}>
                          <Icons.EyeOutline
                            className="icon-eye"
                            size={20}
                          ></Icons.EyeOutline>
                        </Link> */}

                          <Link to={`/subcategory/update/${category._id}`}>
                            <Icons.PencilAltOutline
                              className="icon-edit"
                              size={20}
                            ></Icons.PencilAltOutline>
                          </Link>
                          {auth?.type === "admin" && (
                            <Icons.TrashOutline
                              className="icon-trash"
                              size={20}
                              onClick={() => deleteHandler(category._id)}
                            />
                          )}
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr colSpan={9}>No SubCategories Found</tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      <Toaster position="bottom-right" />
    </div>
  );
};

export default SubCategories;
